import React, { useState } from "react";
import NameStep from "./NameStep";
import MatchUserStep from "./MatchUserStep";
import WaitingScreen from "./WaitingScreen";
import SetupPassword from "./SetupPassword";
import Report from "./Report";
import useAxios from "../../hooks/useAxios";
const defaultFormData = {
  firstName: '',
  middleName: '',
  lastName: '',
  isPrecintChair: 'No', // Default value
  precinctNumber: '',
  schoolDistrict: ''
};

export const STEPS = {
  INPUT_FULL_NAME: "input-full-name",
  CANT_FIND_VOTER_ID: "cant-find-voter-id",
  MATCH_USER: "match-user",
  SELECT_ROLE: "select-role",
  COMPLETE_SIGNUP: "complete-signup",
};

const Main = () => {
  const [step, setStep] = useState(STEPS.INPUT_FULL_NAME);
  const [isWaiting, setIsWaiting] = useState(false);
  const [fetchedVoters, setFetchedVoters] = useState(null);
  const [formData, setFormData] = useState(defaultFormData);
  const [previousFormData, setPreviousFormData] = useState(null);
  const [shoolAndpchNoData,setSchoolAndpchnoData] = useState({});
  const { post } = useAxios();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const restart = () => {
    // setFetchedVoters(null);
    setStep(STEPS.INPUT_FULL_NAME);
    // setFormData(defaultFormData);
  };


  const handleSubmitNameStep = async () => {
    setIsWaiting(true);
    try {
      let obj =  {
        purpose: "submit_name",
        first_name: formData.firstName.toLowerCase().trim(),
        middle_name: formData.middleName.toLowerCase().trim(),
        last_name: formData.lastName.toLowerCase().trim(),
        school_district: formData.schoolDistrict
      }
      if (formData.isPrecintChair === 'Yes') {
        obj.pct_ch_no = Number(formData.precinctNumber)
      }
      await post(
        process.env.REACT_APP_EMAIL_SIGNUP_API_URL,
        obj,
        (response) => {
          setIsWaiting(false);
          setSchoolAndpchnoData({
            pct_ch_no: response.data.data.pct_ch_no,
            school_district: response.data.data.school_district
          })
          setFetchedVoters(response.data.data.results);
          setStep(STEPS.MATCH_USER);
        },
        () => {
          setIsWaiting(false);
        }
      );
    } catch (error) {
        console.error(error);
    }
  }

  return (
    <>
      {step === STEPS.INPUT_FULL_NAME && (
        <NameStep
          formData={formData}
          handleChange={handleChange}
          setStep={setStep}
          setFetchedVoters={setFetchedVoters}
          setPreviousFormData={setPreviousFormData}
          isWaiting={isWaiting}
          handleSubmitNameStep={handleSubmitNameStep}
        />
      )}
        {step === STEPS.MATCH_USER && (
          <MatchUserStep
            restart={restart}
            fetchedVoters={fetchedVoters}
            setIsWaiting={setIsWaiting}
            setStep={setStep}
            shoolAndpchNoData={shoolAndpchNoData}
          />
        )}
        {step === STEPS.COMPLETE_SIGNUP && isWaiting === true && (
          <WaitingScreen />
        )}

        {step === STEPS.COMPLETE_SIGNUP && isWaiting === false && (
          <SetupPassword />
        )}
        {step === STEPS.CANT_FIND_VOTER_ID && (
          <Report setStep={setStep} previousFormData={previousFormData} />
        )}
    </>
  );
};

export default Main;
